export default "__VITE_ASSET__CUEv27K0__"